//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CloudDM.js";
import "../no/Object.js";
import "../CloudDM/CloudDM.DataManager.js";
let d=[[],[[["inputPart","numDocuments"],"GetAssociatedDocumentList",{R_:{documents:"CloudDM.DocumentIdentifier[]"}},1,0],[["inputPart","documents"],"DownloadAssociatedDocuments",{},2,0],[["inputPart","numFiles"],"GetAssociatedFileListForUpload",{R_:{fileList:""}},1,0],[["inputPart","fileList"],"UploadAssociatedDocuments",{},2,0]],[]];
SPLM.CloudDM.FileManagement = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CloudDM.FileManagement";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CloudDM.FileManagement.FileInfo = class{
    constructor(filePath,fileType,isText){
        this.filePath=filePath;this.fileType=fileType;this.isText=isText;}
    get Filepath(){return this.filePath}
    set Filepath(val){this.filePath = val}
    get Filetype(){return this.fileType}
    set Filetype(val){this.fileType = val}
    get Istext(){return this.isText}
    set Istext(val){this.isText = val}
};

export default SPLM;